module.exports = __webpack_public_path__ + "static/media/sunday_times_footy2024.20d02255.webp";